import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Link } from "react-router-dom";
import { Toaster } from "sonner";
import "./smartreach.css";

// SmartReachAI surfaces
import SrHome from "./pages/smartreach/Home";
import SrHomeV2 from "./pages/smartreach/HomeV2";
import SrFootfallSample from "./pages/smartreach/FootfallSampleReport";
import SrPlatformPromotions from "./pages/smartreach/PlatformPromotions";
import SrCredits from "./pages/smartreach/Credits";
import SrSmartReachCredit from "./pages/smartreach/SmartReachCredit";
import SrSmartReachEvent from "./pages/smartreach/SmartReachEvent";
import SrMetaAds from "./pages/smartreach/MetaAdsWorkspace";
import SrLiveCampaigns from "./pages/smartreach/LiveCampaigns";
import SrGoLiveQueue from "./pages/smartreach/GoLiveQueue";
import SrActAsRedirect from "./pages/smartreach/ActAsRedirect";
import SrAdminSpendCaps from "./pages/smartreach/AdminSpendCaps";
import SrSales from "./pages/smartreach/Sales";
import SrTrackingHealth from "./pages/smartreach/TrackingHealth";
import SrMyClients from "./pages/smartreach/MyClients";
import SrMetaStatements from "./pages/smartreach/MetaStatements";
import SrHomeClassic from "./pages/smartreach/HomeClassic";
import SignIn from "./pages/smartreach/SignIn";
import SrWhiteLabelEntry from "./pages/smartreach/WhiteLabelEntry";
import {
  HowItWorks as SrHowItWorks, Solution as SrSolution, CompetitorTargeting as SrCompetitor,
  VisitIntelligence as SrVisit, RadioDigital as SrRadioDigital, ProfessionalService as SrProService,
  Legal as SrLegal, Comparison as SrComparison, Pricing as SrPricingPage,
  FootfallAttribution as SrFootfall, MovieMarketing as SrMovieMarketing,
  ChatGptAdsPage as SrChatGptAdsChannel, DigitalBillboardsPage as SrDigitalBillboards,
} from "./pages/smartreach/Pages";
import AppShell from "./components/smartreach/AppShell";
import AppHome from "./pages/smartreach/AppHome";
import SrOnboarding from "./pages/smartreach/Onboarding";
import SrGrowthPlan from "./pages/smartreach/GrowthPlan";
import SrEasyCampaign from "./pages/smartreach/EasyCampaign";
import SrClientHub from "./pages/smartreach/ClientHub";
import SrBonusInventory from "./components/smartreach/BonusInventory";
import SrAiAdStudio from "./pages/smartreach/AiAdStudio";
import SrWhatsNewApp from "./pages/smartreach/WhatsNewApp";
import SrPricingEngine from "./pages/smartreach/PricingEngineEmbed";
import SrMediaMix from "./pages/smartreach/MediaMix";
import SrRadioAudiences from "./pages/smartreach/RadioAudiences";
import SrOpsTasks from "./pages/smartreach/OpsTasks";
import SrAdminClientApprovals from "./pages/smartreach/AdminClientApprovals";
import SrAdminRadioFlights from "./pages/smartreach/AdminRadioFlights";
import SrSmsOptIn from "./pages/smartreach/SmsOptIn";
import SrAdminSmsOptIns from "./pages/smartreach/AdminSmsOptIns";
import SrClientRadioFlights from "./pages/smartreach/ClientRadioFlights";
import SrCompetitors from "./pages/smartreach/Competitors";
import SrRedeem from "./pages/smartreach/Redeem";
import SrScanRedeem, { CounterMode as SrCounterMode } from "./pages/smartreach/ScanRedeem";
import SrLoyalty from "./pages/smartreach/Loyalty";
import SrAICampaign from "./pages/smartreach/AICampaignBuilder";
import SrVideoStudio from "./pages/smartreach/VideoStudio";
import SrLeads from "./pages/smartreach/Leads";
import SrInbox from "./pages/smartreach/Inbox";
import SrGoogleAds from "./pages/smartreach/GoogleAds";
import SrFunAsia from "./pages/smartreach/FunAsia";
import SrFranchise from "./pages/smartreach/Franchise";
import SrVoiceLibrary from "./pages/smartreach/VoiceLibrary";
import SrSettlements from "./pages/smartreach/Settlements";
import SrCatalog from "./pages/smartreach/Catalog";
import SrComplianceCertificate from "./pages/smartreach/ComplianceCertificate";
import SrAgencyPortfolio from "./pages/smartreach/AgencyPortfolio";
import SrAdminClients from "./pages/smartreach/AdminClients";
import SrAdminClientDetail from "./pages/smartreach/AdminClientDetail";
import SrAdminUsers from "./pages/smartreach/AdminUsers";
import SrAdminActivity from "./pages/smartreach/AdminActivity";
import SrAdminWorkload from "./pages/smartreach/AdminWorkload";
import SrAdminQueue from "./pages/smartreach/AdminQueue";
import SrAdminRoles from "./pages/smartreach/AdminRoles";
import SrCampaignProject from "./pages/smartreach/CampaignProject";
import SrWorkQueue from "./pages/smartreach/WorkQueue";
import SrMyAccess from "./pages/smartreach/MyAccess";
import SrOpsBoard from "./pages/smartreach/OpsBoard";
import SrClientPortal from "./pages/smartreach/ClientPortal";
import SrDomains from "./pages/smartreach/Domains";
import SrAdminDomains from "./pages/smartreach/AdminDomains";
import SrRetargeting from "./pages/smartreach/Retargeting";
import SrInventoryGuard from "./pages/smartreach/InventoryGuard";
import SrReleaseCalendar from "./pages/smartreach/ReleaseCalendar";
import SrSalesReport from "./pages/smartreach/SalesReport";
import SrMarginReport from "./pages/smartreach/MarginReport";
import SrDynamicProductAds from "./pages/smartreach/DynamicProductAds";
import SrBudgetRecommendations from "./pages/smartreach/BudgetRecommendations";
import SrCustomerLists from "./pages/smartreach/CustomerLists";
import SrProposalStudio from "./pages/smartreach/ProposalStudio";
import SrProposalDetail from "./pages/smartreach/ProposalDetail";
import SrPublicProposal from "./pages/smartreach/PublicProposal";
import SrDoohAds from "./pages/smartreach/DoohAds";
import SrChatGptAds from "./pages/smartreach/ChatGptAds";
import SrMovieStudio from "./pages/smartreach/MovieStudio";
import SrAppAudiences from "./pages/smartreach/AppAudiences";
import SrPoliticalStudio from "./pages/smartreach/PoliticalStudio";
import SrOverdueApprovals from "./pages/smartreach/OverdueApprovals";
import SrPlacesImport from "./pages/smartreach/PlacesImport";
import SrMoreTools from "./pages/smartreach/MoreTools";
import SrClientDashboard from "./pages/smartreach/ClientDashboard";
import {
  OffersList as SrOffersList, OfferNew as SrOfferNew, OfferTemplates as SrOfferTemplates,
  OfferDetail as SrOfferDetail, WalletPasses as SrWalletPasses, WalletPassDetail as SrWalletPassDetail,
  WalletSettings as SrWalletSettings, OfferMatchback as SrOfferMatchback,
  OpsWalletIssuance as SrOpsWalletIssuance, OpsOfferRedemption as SrOpsOfferRedemption,
  OpsOfferReconciliation as SrOpsOfferReconciliation,
} from "./pages/smartreach/OfferStudio";
import SrOfferLanding from "./pages/smartreach/OfferLanding";
import SrSuccessStory from "./pages/smartreach/screens/SuccessStory";
import {
  Locations as SrLocations, Campaigns as SrCampaigns, Results as SrResults, Creative as SrCreative,
  Customers as SrCustomers, RadioCenter as SrRadioCenter, Services as SrServices, Settings as SrSettings, Ops as SrOps, Autopilot as SrAutopilot,
} from "./pages/smartreach/AppScreens";

import { auth } from "./lib/api";
import Layout from "./components/Layout";
import { UpgradeGate } from "./components/UpgradeGate";
import Login from "./pages/Login";
import Onboarding from "./pages/Onboarding";
import Home from "./pages/Home";
import Campaigns from "./pages/Campaigns";
import CampaignBuilder from "./pages/CampaignBuilder";
import CreateCampaignChoice from "./pages/CreateCampaignChoice";
import CampaignAgent from "./pages/CampaignAgent";
import CTVCampaignBuilder from "./pages/CTVCampaignBuilder";
import Creatives from "./pages/Creatives";
import Audiences from "./pages/Audiences";
import GeoIntelligence from "./pages/GeoIntelligence";
import Footfall from "./pages/Footfall";
import FirstPartyData from "./pages/FirstPartyData";
import RadioInventory from "./pages/RadioInventory";
import AIAssistant from "./pages/AIAssistant";
import AICreativeStudio from "./pages/AICreativeStudio";
import AILandingPageBuilder from "./pages/AILandingPageBuilder";
import Political from "./pages/Political";
import Reports from "./pages/Reports";
import Billing from "./pages/Billing";
import AdminSettings from "./pages/AdminSettings";
import AuditLogs from "./pages/AuditLogs";
import PoliticalOrganizations from "./pages/PoliticalOrganizations";
import TargetVoters from "./pages/TargetVoters";
import PoliticalData from "./pages/PoliticalData";
import PricingEngine from "./pages/PricingEngine";
import Welcome from "./pages/Welcome";
import WhatsNew from "./pages/WhatsNew";
import StackAdaptAdmin from "./pages/StackAdaptAdmin";
import CandidateDirectory from "./pages/CandidateDirectory";
import RacePage from "./pages/RacePage";
import PublicDirectory from "./pages/PublicDirectory";
import CTVPlanner from "./pages/CTVPlanner";
import ComplianceCenter from "./pages/ComplianceCenter";
import FundraisingDashboard from "./pages/fundraising/Dashboard";
import FundraisingCampaigns from "./pages/fundraising/Campaigns";
import LandingPages from "./pages/fundraising/LandingPages";
import Microsites from "./pages/fundraising/Microsites";
import Donors from "./pages/fundraising/Donors";
import Transactions from "./pages/fundraising/Transactions";
import SourceEconomics from "./pages/SourceEconomics";
import AgencyPortfolio from "./pages/AgencyPortfolio";
import AgencyTeam from "./pages/AgencyTeam";
import OnboardingChecklist from "./pages/OnboardingChecklist";
import BrandLibrary from "./pages/BrandLibrary";
import AdStudioRefreshes from "./pages/AdStudioRefreshes";
import SmsKeywords from "./pages/SmsKeywords";
import Microsite, { MicrositeThanks } from "./pages/Microsite";
import PhotoGallery from "./pages/intelligence/PhotoGallery";
import EntityOnboarding from "./pages/EntityOnboarding";
import RaceIntelligence from "./pages/RaceIntelligence";
import TeamDirectory from "./pages/TeamDirectory";
import AcceptInvite from "./pages/AcceptInvite";
import CampaignCalendar from "./pages/CampaignCalendar";
import OperationsHub from "./pages/OperationsHub";
import Portfolio from "./pages/Portfolio";
import ClaimsVault from "./pages/ClaimsVault";
import EventsPage from "./pages/EventsPage";
import PublicEvent from "./pages/PublicEvent";
import Volunteers from "./pages/Volunteers";
import AdLibraryPage from "./pages/AdLibraryPage";
import ElectionNight from "./pages/ElectionNight";
import QrCodes from "./pages/QrCodes";
import AskTotalReach from "./pages/AskTotalReach";
import { CTVReports } from "./pages/_Placeholders";
import MediaPlans from "./pages/MediaPlans";
import OtherTargeting from "./pages/OtherTargeting";
import HelpCenter from "./pages/HelpCenter";
import Optimize from "./pages/Optimize";
import WarRoom from "./pages/WarRoom";
import OpponentIntel from "./pages/OpponentIntel";
import Intelligence from "./pages/Intelligence";
import AdStudio from "./pages/AdStudio";
import AdStudioProject from "./pages/AdStudioProject";
import EmailCampaigns from "./pages/EmailCampaigns";
import DirectMail from "./pages/DirectMail";
import Journeys from "./pages/Journeys";
import PoliticalIntelligence from "./pages/PoliticalIntelligence";
import CandidateDashboard from "./pages/CandidateDashboard";
import SharedRace from "./pages/SharedRace";
import VolunteerPortal from "./pages/VolunteerPortal";
import VolunteerLeaderboard from "./pages/VolunteerLeaderboard";

const ProtectedRoute = ({ children }) => {
  const user = auth.getUser();
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const RootGate = () => {
  const user = auth.getUser();
  if (user) return <Navigate to="/app" replace />;
  return <SrHomeV2 />;
};

const MICROSITE_ROOT = "totalreach.us";
const RESERVED_SUBDOMAINS = ["www", "app", "api", "mg", "email", "mail", "admin"];

function detectMicrositeSlug() {
  const host = window.location.hostname;
  if (!host.endsWith(`.${MICROSITE_ROOT}`)) return null;
  const sub = host.slice(0, -(MICROSITE_ROOT.length + 1));
  if (!sub || sub.includes(".") || RESERVED_SUBDOMAINS.includes(sub)) return null;
  return sub;
}

function App() {
  const micrositeSlug = detectMicrositeSlug();
  if (micrositeSlug) {
    return (
      <div className="App min-h-screen bg-[#0A0E1A] text-white">
        <Toaster theme="dark" position="bottom-right" />
        <BrowserRouter>
          <Routes>
            <Route path="/thanks" element={<MicrositeThanks slugOverride={micrositeSlug} />} />
            <Route path="*" element={<Microsite slugOverride={micrositeSlug} />} />
          </Routes>
        </BrowserRouter>
      </div>
    );
  }
  return (
    <div className="App min-h-screen bg-[#0A0E1A] text-white">
      <Toaster theme="dark" position="bottom-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootGate />} />
          {/* Old homepages preserved for internal comparison — not visitor-facing */}
          <Route path="/legacy/home" element={<SrHome />} />
          <Route path="/legacy/home-classic" element={<SrHomeClassic />} />
          <Route path="/login" element={<SignIn mode="signin" />} />
          <Route path="/signup" element={<SignIn mode="signup" />} />
          <Route path="/a/:slug" element={<SrWhiteLabelEntry />} />
          <Route path="/w/:slug" element={<SrWhiteLabelEntry />} />
          <Route path="/legacy-login" element={<Login />} />

          {/* SmartReachAI public marketing site */}
          <Route path="/how-it-works" element={<SrHowItWorks />} />
          <Route path="/solutions/movie-marketing" element={<SrMovieMarketing />} />
          <Route path="/channels/chatgpt-ads" element={<SrChatGptAdsChannel />} />
          <Route path="/channels/digital-billboards" element={<SrDigitalBillboards />} />
          <Route path="/solutions/:slug" element={<SrSolution />} />
          <Route path="/competitor-targeting" element={<SrCompetitor />} />
          <Route path="/visit-intelligence" element={<SrVisit />} />
          <Route path="/footfall-attribution" element={<SrFootfall />} />
          <Route path="/footfall-attribution/sample-report" element={<SrFootfallSample />} />
          <Route path="/radio-digital" element={<SrRadioDigital />} />
          <Route path="/professional-service" element={<SrProService />} />
          <Route path="/comparison" element={<SrComparison />} />
          <Route path="/pricing" element={<SrPricingPage />} />
          <Route path="/privacy" element={<SrLegal kind="privacy" />} />
          <Route path="/terms" element={<SrLegal kind="terms" />} />
          <Route path="/sms-opt-in" element={<SrSmsOptIn />} />
          <Route path="/r/:code" element={<SrRedeem />} />
          <Route path="/p/:token" element={<SrPublicProposal />} />
          <Route path="/counter" element={<SrCounterMode />} />
          <Route path="/o/:token" element={<SrOfferLanding />} />
          <Route path="/smartreach-credit/:code" element={<SrSmartReachCredit />} />
          <Route path="/event/:slug" element={<SrSmartReachEvent />} />
          <Route path="/clients/:token" element={<SrClientDashboard />} />

          {/* SmartReachAI authenticated SMB app */}
          <Route path="/app" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
            <Route index element={<AppHome />} />
            <Route path="onboarding" element={<SrOnboarding />} />
            <Route path="growth-plan" element={<SrGrowthPlan />} />
            <Route path="easy" element={<SrEasyCampaign />} />
            <Route path="dashboard" element={<SrClientHub />} />
            <Route path="bonus" element={<SrBonusInventory />} />
            <Route path="ai-ad" element={<SrAiAdStudio />} />
            <Route path="whats-new" element={<SrWhatsNewApp />} />
            <Route path="admin/pricing" element={<SrPricingEngine />} />
            <Route path="credits" element={<SrAiAdStudio />} />
            <Route path="media-mix" element={<SrMediaMix />} />
            <Route path="admin/radio-audiences" element={<SrRadioAudiences />} />
            <Route path="admin/ops-tasks" element={<SrOpsTasks />} />
            <Route path="admin/client-approvals" element={<SrAdminClientApprovals />} />
            <Route path="admin/radio-flights" element={<SrAdminRadioFlights />} />
            <Route path="admin/sms-optins" element={<SrAdminSmsOptIns />} />
            <Route path="radio-flights" element={<SrClientRadioFlights />} />
            <Route path="autopilot" element={<SrAutopilot />} />
            <Route path="campaigns" element={<SrCampaigns />} />
            <Route path="campaigns/new" element={<SrAICampaign />} />
            <Route path="locations" element={<SrLocations />} />
            <Route path="competitors" element={<SrCompetitors />} />
            <Route path="creative" element={<SrCreative />} />
            <Route path="catalog" element={<SrCatalog />} />
            <Route path="video" element={<SrVideoStudio />} />
            <Route path="video/library" element={<SrVoiceLibrary />} />
            <Route path="settlements" element={<SrSettlements />} />
            <Route path="offers" element={<SrOffersList />} />
            <Route path="offers/redeem" element={<SrScanRedeem />} />
            <Route path="offers/new" element={<SrOfferNew />} />
            <Route path="offers/templates" element={<SrOfferTemplates />} />
            <Route path="offers/matchback" element={<SrOfferMatchback />} />
            <Route path="wallet-settings" element={<SrWalletSettings />} />
            <Route path="offers/:id" element={<SrOfferDetail tab="overview" />} />
            <Route path="offers/:id/design" element={<SrOfferDetail tab="design" />} />
            <Route path="offers/:id/landing-page" element={<SrOfferDetail tab="landing-page" />} />
            <Route path="offers/:id/distribution" element={<SrOfferDetail tab="distribution" />} />
            <Route path="offers/:id/redemptions" element={<SrOfferDetail tab="redemptions" />} />
            <Route path="wallet-passes" element={<SrWalletPasses />} />
            <Route path="wallet-passes/:id" element={<SrWalletPassDetail />} />
            <Route path="campaigns/:id/offer" element={<SrOfferNew />} />
            <Route path="campaigns/:id/creative-offer" element={<SrOfferNew />} />
            <Route path="loyalty" element={<SrLoyalty />} />
            <Route path="leads" element={<SrLeads />} />
            <Route path="inbox" element={<SrInbox />} />
            <Route path="google-ads" element={<SrGoogleAds />} />
            <Route path="funasia" element={<SrFunAsia />} />
            <Route path="franchise" element={<SrFranchise />} />
            <Route path="agency" element={<SrAgencyPortfolio />} />
            <Route path="admin/clients" element={<SrAdminClients />} />
            <Route path="admin/live-campaigns" element={<SrLiveCampaigns />} />
            <Route path="admin/spend-caps" element={<SrAdminSpendCaps />} />
            <Route path="my-clients" element={<SrMyClients />} />
            <Route path="sales" element={<SrSales />} />
            <Route path="tracking-health" element={<SrTrackingHealth />} />
            <Route path="admin/clients/:tenantId" element={<SrAdminClientDetail />} />
            <Route path="admin/users" element={<SrAdminUsers />} />
            <Route path="admin/activity" element={<SrAdminActivity />} />
            <Route path="admin/workload" element={<SrAdminWorkload />} />
            <Route path="admin/queue" element={<SrAdminQueue />} />
            <Route path="admin/roles" element={<SrAdminRoles />} />
            <Route path="admin/go-live" element={<SrGoLiveQueue />} />
            <Route path="act-as/:tid" element={<SrActAsRedirect />} />
            <Route path="campaigns/:cid/project" element={<SrCampaignProject />} />
            <Route path="work" element={<SrWorkQueue />} />
            <Route path="my-access" element={<SrMyAccess />} />
            <Route path="ops/digital" element={<SrOpsBoard kind="digital" />} />
            <Route path="ops/radio" element={<SrOpsBoard kind="radio" />} />
            <Route path="portal" element={<SrClientPortal />} />
            <Route path="domains" element={<SrDomains />} />
            <Route path="admin/domains" element={<SrAdminDomains />} />
            <Route path="retargeting" element={<SrRetargeting />} />
            <Route path="inventory-guard" element={<SrInventoryGuard />} />
            <Route path="release-calendar" element={<SrReleaseCalendar />} />
            <Route path="sales-report" element={<SrSalesReport />} />
            <Route path="dynamic-ads" element={<SrDynamicProductAds />} />
            <Route path="budget-recommendations" element={<SrBudgetRecommendations />} />
            <Route path="customer-lists" element={<SrCustomerLists />} />
            <Route path="proposals" element={<SrProposalStudio />} />
            <Route path="proposals/:id" element={<SrProposalDetail />} />
            <Route path="dooh" element={<SrDoohAds />} />
            <Route path="chatgpt-ads" element={<SrChatGptAds />} />
            <Route path="movie-studio" element={<SrMovieStudio />} />
            <Route path="movie-studio/:itemId" element={<SrMovieStudio />} />
            <Route path="audiences" element={<SrAppAudiences />} />
            <Route path="political-studio" element={<SrPoliticalStudio />} />
            <Route path="admin/overdue" element={<SrOverdueApprovals />} />
            <Route path="admin/import" element={<SrPlacesImport />} />
            <Route path="admin/promotions" element={<SrPlatformPromotions />} />
            <Route path="credits" element={<SrCredits />} />
            <Route path="meta-ads" element={<SrMetaAds />} />
            <Route path="meta-statements" element={<SrMetaStatements />} />
            <Route path="more" element={<SrMoreTools />} />
            <Route path="compliance-certificate/:planId" element={<SrComplianceCertificate />} />
            <Route path="customers" element={<SrCustomers />} />
            <Route path="results" element={<SrResults />} />
            <Route path="admin/margin-report" element={<SrMarginReport />} />
            <Route path="success-story" element={<SrSuccessStory />} />
            <Route path="radio" element={<SrRadioCenter />} />
            <Route path="services" element={<SrServices />} />
            <Route path="settings" element={<SrSettings />} />
          </Route>
          <Route path="/ops" element={<ProtectedRoute><SrOps /></ProtectedRoute>} />
          <Route path="/ops/wallet-issuance" element={<ProtectedRoute><SrOpsWalletIssuance /></ProtectedRoute>} />
          <Route path="/ops/offer-redemption" element={<ProtectedRoute><SrOpsOfferRedemption /></ProtectedRoute>} />
          <Route path="/ops/offer-reconciliation" element={<ProtectedRoute><SrOpsOfferReconciliation /></ProtectedRoute>} />

          <Route path="/request-demo" element={<Login mode="demo" />} />
          <Route path="/reset-password" element={<Login mode="reset" />} />
          <Route path="/directory" element={<PublicDirectory />} />
          <Route path="/directory/race/:raceId" element={<RacePage publicMode />} />
          <Route path="/whats-new" element={<WhatsNew />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/m/:slug" element={<Microsite />} />
          <Route path="/m/:slug/thanks" element={<MicrositeThanks />} />
          <Route path="/race/:token" element={<SharedRace />} />
          <Route path="/volunteer/:token" element={<VolunteerPortal />} />
          <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
          <Route path="/onboarding/political" element={<ProtectedRoute><EntityOnboarding /></ProtectedRoute>} />
          <Route path="/accept-invite/:token" element={<ProtectedRoute><AcceptInvite /></ProtectedRoute>} />
          <Route path="/e/:slug" element={<PublicEvent />} />
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/dashboard" element={<Home />} />
            <Route path="/ask-totalreach" element={<UpgradeGate feature="ai" title="Ask TotalReach — AI Chief of Staff"><AskTotalReach /></UpgradeGate>} />
            <Route path="/war-room" element={<UpgradeGate feature="war_room" title="The Campaign War Room"><WarRoom /></UpgradeGate>} />

            {/* Advertise */}
            <Route path="/campaigns" element={<Campaigns />} />
            <Route path="/campaigns/new" element={<CreateCampaignChoice />} />
            <Route path="/campaigns/new/pro" element={<CampaignBuilder />} />
            <Route path="/campaign-agent/:sid" element={<UpgradeGate feature="ai" title="The AI Campaign Agent"><CampaignAgent /></UpgradeGate>} />
            <Route path="/campaigns/:id" element={<CampaignBuilder />} />
            <Route path="/campaigns/ctv/new" element={<CTVCampaignBuilder />} />
            <Route path="/planner/ctv" element={<CTVPlanner />} />
            <Route path="/media-plans" element={<MediaPlans />} />
            <Route path="/email-campaigns" element={<UpgradeGate feature="email" title="Email Campaigns"><EmailCampaigns /></UpgradeGate>} />
            <Route path="/direct-mail" element={<UpgradeGate feature="direct_mail" title="Programmatic Direct Mail"><DirectMail /></UpgradeGate>} />
            <Route path="/journeys" element={<UpgradeGate feature="journeys" title="Omnichannel Journeys"><Journeys /></UpgradeGate>} />

            {/* Target */}
            <Route path="/target-voters" element={<TargetVoters />} />
            <Route path="/political-data" element={<PoliticalData />} />
            <Route path="/audiences" element={<Audiences />} />
            <Route path="/first-party" element={<UpgradeGate feature="voter_files" title="Voter File Onboarding"><FirstPartyData /></UpgradeGate>} />
            <Route path="/geo" element={<GeoIntelligence />} />
            <Route path="/other-targeting" element={<OtherTargeting />} />

            {/* Fundraise */}
            <Route path="/fundraising" element={<UpgradeGate feature="fundraising" title="The Fundraising Suite"><FundraisingDashboard /></UpgradeGate>} />
            <Route path="/fundraising/campaigns" element={<UpgradeGate feature="fundraising" title="Fundraising Campaigns"><FundraisingCampaigns /></UpgradeGate>} />
            <Route path="/fundraising/campaigns/:id" element={<UpgradeGate feature="fundraising" title="Fundraising Campaigns"><FundraisingCampaigns /></UpgradeGate>} />
            <Route path="/fundraising/landing-pages" element={<UpgradeGate feature="fundraising" title="Landing Pages"><LandingPages /></UpgradeGate>} />
            <Route path="/fundraising/microsites" element={<UpgradeGate feature="fundraising" title="Microsites"><Microsites /></UpgradeGate>} />
            <Route path="/fundraising/donors" element={<UpgradeGate feature="fundraising" title="The Donor CRM"><Donors /></UpgradeGate>} />
            <Route path="/fundraising/transactions" element={<UpgradeGate feature="fundraising" title="Transactions"><Transactions /></UpgradeGate>} />
            <Route path="/fundraising/economics" element={<UpgradeGate feature="fundraising" title="Fundraising Source Economics"><SourceEconomics /></UpgradeGate>} />

            {/* Create */}
            <Route path="/ad-studio" element={<UpgradeGate feature="ai" title="The Political Ad Studio"><AdStudio /></UpgradeGate>} />
            <Route path="/ad-studio/:id" element={<UpgradeGate feature="ai" title="The Political Ad Studio"><AdStudioProject /></UpgradeGate>} />
            <Route path="/ai-assistant" element={<UpgradeGate feature="ai" title="The AI Campaign Assistant"><AIAssistant /></UpgradeGate>} />
            <Route path="/creative-studio" element={<UpgradeGate feature="ai" title="The AI Creative Studio"><AICreativeStudio /></UpgradeGate>} />
            <Route path="/ai-landing-page" element={<UpgradeGate feature="ai" title="The AI Landing Page Builder"><AILandingPageBuilder /></UpgradeGate>} />
            <Route path="/creatives" element={<Creatives />} />

            {/* Intelligence */}
            <Route path="/political-intelligence" element={<UpgradeGate feature="intelligence" title="Political Intelligence"><PoliticalIntelligence /></UpgradeGate>} />
            <Route path="/race-intelligence" element={<RaceIntelligence />} />
            <Route path="/team" element={<TeamDirectory />} />
            <Route path="/calendar" element={<CampaignCalendar />} />
            <Route path="/operations" element={<OperationsHub />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/agency" element={<UpgradeGate feature="agency" title="Agency Portfolio"><AgencyPortfolio /></UpgradeGate>} />
            <Route path="/agency/team" element={<UpgradeGate feature="agency" title="Agency Team"><AgencyTeam /></UpgradeGate>} />
            <Route path="/onboarding/checklist" element={<OnboardingChecklist />} />
            <Route path="/brand-library" element={<BrandLibrary />} />
            <Route path="/ad-studio/refreshes" element={<UpgradeGate feature="ai" title="Ad Studio Weekly Refresh"><AdStudioRefreshes /></UpgradeGate>} />
            <Route path="/fundraising/sms" element={<UpgradeGate feature="fundraising" title="Text-to-Give SMS"><SmsKeywords /></UpgradeGate>} />
            <Route path="/claims-vault" element={<ClaimsVault />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/volunteers" element={<Volunteers />} />
            <Route path="/volunteers/leaderboard" element={<VolunteerLeaderboard />} />
            <Route path="/ad-library" element={<AdLibraryPage />} />
            <Route path="/election-night" element={<ElectionNight />} />
            <Route path="/qr-codes" element={<QrCodes />} />
            <Route path="/qr" element={<QrCodes />} />
            <Route path="/political-intelligence/:id" element={<UpgradeGate feature="intelligence" title="Political Intelligence"><CandidateDashboard /></UpgradeGate>} />
            <Route path="/political-intelligence/:id/photos" element={<UpgradeGate feature="intelligence" title="Political Intelligence"><PhotoGallery /></UpgradeGate>} />
            <Route path="/midterms" element={<CandidateDirectory />} />
            <Route path="/midterms/race/:raceId" element={<RacePage />} />
            <Route path="/intelligence" element={<Intelligence />} />
            <Route path="/political" element={<Political />} />
            <Route path="/opponent" element={<OpponentIntel />} />

            {/* Measure */}
            <Route path="/reports" element={<Reports />} />
            <Route path="/reports/ctv" element={<CTVReports />} />
            <Route path="/optimize" element={<Optimize />} />

            {/* Compliance */}
            <Route path="/compliance" element={<UpgradeGate feature="compliance" title="The Compliance Center"><ComplianceCenter /></UpgradeGate>} />
            <Route path="/audit" element={<AuditLogs />} />

            {/* Account */}
            <Route path="/organizations" element={<PoliticalOrganizations />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/pricing/admin" element={<PricingEngine />} />
            <Route path="/ad-platform" element={<StackAdaptAdmin />} />
            <Route path="/admin" element={<AdminSettings />} />
            <Route path="/help" element={<HelpCenter />} />

            {/* Legacy — keep for regression */}
            <Route path="/radio" element={<RadioInventory />} />
            <Route path="/footfall" element={<Footfall />} />
          </Route>
        </Routes>
        <footer data-testid="global-brand-footer" style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "center", gap: 8, textAlign: "center", padding: "10px 16px", fontSize: 11, letterSpacing: 0.3, color: "rgba(255,255,255,0.45)", background: "#0A0E1A", borderTop: "1px solid rgba(255,255,255,0.06)" }}>
          <Link to="/privacy" data-testid="footer-privacy" style={{ color: "rgba(255,255,255,0.62)", textDecoration: "none" }}>Privacy</Link>
          <span style={{ opacity: 0.4 }}>·</span>
          <Link to="/terms" data-testid="footer-terms" style={{ color: "rgba(255,255,255,0.62)", textDecoration: "none" }}>Terms</Link>
          <span style={{ opacity: 0.4 }}>·</span>
          <a href="mailto:support@smartreachai.us" data-testid="footer-support" style={{ color: "rgba(255,255,255,0.62)", textDecoration: "none" }}>Support</a>
          <span style={{ opacity: 0.4 }}>·</span>
          <span data-testid="footer-brand-credit">a Funasia Digital company</span>
        </footer>
      </BrowserRouter>
    </div>
  );
}

export default App;
